import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { verifyMagicLink } from '../../lib/auth';
import { syncLocalAudioAfterLogin } from '../../lib/bootstrap';

export function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setError('No sign-in token found in the link');
        return;
      }

      // Magic links opened on a phone finish in the native app. Keep the
      // browser callback as the source of truth, then hand off the token.
      const isMobile = searchParams.get('platform') === 'mobile' || /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.assign(`pomodingo://auth/callback?token=${encodeURIComponent(token)}`);
        return;
      }

      try {
        await verifyMagicLink(token);
        await syncLocalAudioAfterLogin();
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Error during auth callback:', err);
        setError(err instanceof Error ? err.message : 'Failed to complete sign in');
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        {!error ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-indigo-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-700 dark:text-gray-300">Completing sign in...</p>
          </>
        ) : (
          <p className="text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    </div>
  );
}
